document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("custom-menu-drawer");
  const openBtn = document.getElementById("custom-menu-drawer-open");
  const categoriesToggle = document.getElementById("categories-menu-toggle");
  const closeBtn = document.getElementById("custom-menu-drawer-close");
  const overlay = document.getElementById("custom-menu-drawer-overlay");

  function openDrawer() {
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function toggleDrawer() {
    const isOpen = drawer.getAttribute("aria-hidden") === "false";
    
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  if (openBtn) openBtn.addEventListener("click", openDrawer);
  if (categoriesToggle) categoriesToggle.addEventListener("click", toggleDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeDrawer();
    }
  });
});
